export default {
  $PAC: {
    symbol: '$PAC',
    name: 'PACcoin',
    color: '#f5eb16'
  },
  '0XBTC': {
    symbol: '0XBTC',
    name: '0xBitcoin',
    color: '#ff914d'
  },
  '2GIVE': {
    symbol: '2GIVE',
    name: '2Give',
    color: '#f1cb60'
  },
  AAVE: {
    symbol: 'AAVE',
    name: 'AAVE',
    color: '#2ebac6'
  },
  ABT: {
    symbol: 'ABT',
    name: 'Arcblock',
    color: '#3effff'
  },
  ACT: {
    symbol: 'ACT',
    name: 'Achain',
    color: '#767dff'
  },
  ACTN: {
    symbol: 'ACTN',
    name: 'Action Coin',
    color: '#ffffff'
  },
  ADA: {
    symbol: 'ADA',
    name: 'Cardano',
    color: '#0d1e30',
    image: 'i_ada'
  },
  ADD: {
    symbol: 'ADD',
    name: 'ADD Token',
    color: '#fec807',
    image: 'i_add'
  },
  ADX: {
    symbol: 'ADX',
    name: 'AdEx',
    color: '#1b75bc',
    image: 'i_adx'
  },
  AE: {
    symbol: 'AE',
    name: 'Aeternity',
    color: '#de3f6b'
  },
  AEON: {
    symbol: 'AEON',
    name: 'Aeon',
    color: '#134451'
  },
  AEUR: {
    symbol: 'AEUR',
    name: 'Augmint Euro Token',
    color: '#051d2d'
  },
  AGI: {
    symbol: 'AGI',
    name: 'SingularityNET',
    color: '#6916ff'
  },
  AGRS: {
    symbol: 'AGRS',
    name: 'Agoras Tauchain',
    color: '#f49e00'
  },
  AION: {
    symbol: 'AION',
    name: 'Aion',
    color: '#00bfec'
  },
  ALGO: {
    symbol: 'ALGO',
    name: 'Algorand',
    color: '#000000'
  },
  AMB: {
    symbol: 'AMB',
    name: 'Ambrosus',
    color: '#3c5be0'
  },
  AMP: {
    symbol: 'AMP',
    name: 'HyperSpace (Synereo)',
    color: '#2daee4'
  },
  AMPL: {
    symbol: 'AMPL',
    name: 'Ampleforth',
    color: '#000000'
  },
  ANKR: {
    symbol: 'ANKR',
    name: 'Ankr Network',
    color: '#2e6bf6'
  },
  ANT: {
    symbol: 'ANT',
    name: 'Aragon',
    color: '#2cd3e1'
  },
  APPC: {
    symbol: 'APPC',
    name: 'AppCoins',
    color: '#fd875e'
  },
  ARDR: {
    symbol: 'ARDR',
    name: 'Ardor',
    color: '#3c87c7'
  },
  ARG: {
    symbol: 'ARG',
    name: 'Argentum',
    color: '#a71435'
  },
  ARK: {
    symbol: 'ARK',
    name: 'Ark',
    color: '#f70000'
  },
  ARN: {
    symbol: 'ARN',
    name: 'Aeron',
    color: '#0092b5'
  },
  ARNX: {
    symbol: 'ARNX',
    name: 'Aeron',
    color: '#436697'
  },
  ARY: {
    symbol: 'ARY',
    name: 'Block Array',
    color: '#343434'
  },
  AST: {
    symbol: 'AST',
    name: 'AirSwap',
    color: '#0061ff'
  },
  ATM: {
    symbol: 'ATM',
    name: 'ATMChain',
    color: '#346fce'
  },
  ATOM: {
    symbol: 'ATOM',
    name: 'Cosmos',
    color: '#2e3148'
  },
  AUDR: {
    symbol: 'AUDR',
    name: 'AUDRamp',
    color: '#34318a'
  },
  AUTO: {
    symbol: 'AUTO',
    name: 'Cube',
    color: '#fab431'
  },
  AVAX: {
    symbol: 'AVAX',
    name: 'Avalanche',
    color: '#ffffff'
  },
  AYWA: {
    symbol: 'AYWA',
    name: 'Aywa',
    color: '#3355b5'
  },
  BAB: {
    symbol: 'BAB',
    name: 'Bitcoin Cash ABC',
    color: '#f19f13'
  },
  BAL: {
    symbol: 'BAL',
    name: 'Balancer',
    color: '#1e1e1e'
  },
  BAND: {
    symbol: 'BAND',
    name: 'Band Protocol',
    color: '#516aff'
  },
  BAT: {
    symbol: 'BAT',
    name: 'Basic Attention Token',
    color: '#ff5000'
  },
  BAY: {
    symbol: 'BAY',
    name: 'BitBay',
    color: '#6356ab'
  },
  BCBC: {
    symbol: 'BCBC',
    name: 'BCBC',
    color: '#004ab5'
  },
  BCC: {
    symbol: 'BCC',
    name: 'BCC',
    color: '#f7931c'
  },
  BCD: {
    symbol: 'BCD',
    name: 'Bitcoin Diamond',
    color: '#fcc339'
  },
  BCH: {
    symbol: 'BCH',
    name: 'Bitcoin Cash',
    color: '#8dc351'
  },
  BCIO: {
    symbol: 'BCIO',
    name: 'Blockchain.io',
    color: '#3f43ad'
  },
  BCN: {
    symbol: 'BCN',
    name: 'Bytecoin',
    color: '#f04086'
  },
  BCO: {
    symbol: 'BCO',
    name: 'BananaCoin',
    color: '#2c76b7'
  },
  BCPT: {
    symbol: 'BCPT',
    name: 'BlockMason Credit Protocol',
    color: '#404040'
  },
  BDL: {
    symbol: 'BDL',
    name: 'Bitdeal',
    color: '#e54c40'
  },
  BEAM: {
    symbol: 'BEAM',
    name: 'Beam',
    color: '#0b76ff'
  },
  BELA: {
    symbol: 'BELA',
    name: 'Belacoin',
    color: '#13a0f6'
  },
  BIX: {
    symbol: 'BIX',
    name: 'Bibox Token',
    color: '#000000'
  },
  BLCN: {
    symbol: 'BLCN',
    name: 'BLCN',
    color: '#2aabe4'
  },
  BLK: {
    symbol: 'BLK',
    name: 'BlackCoin',
    color: '#181818'
  },
  BLOCK: {
    symbol: 'BLOCK',
    name: 'Blocknet',
    color: '#101341'
  },
  BLZ: {
    symbol: 'BLZ',
    name: 'Blazecoin',
    color: '#18578c'
  },
  BNB: {
    symbol: 'BNB',
    name: 'Binance Coin',
    color: '#f3ba2f'
  },
  BNT: {
    symbol: 'BNT',
    name: 'Bancor Network Token',
    color: '#000d2b'
  },
  BNTY: {
    symbol: 'BNTY',
    name: 'Bounty0x',
    color: '#fd7a3d'
  },
  BOOTY: {
    symbol: 'BOOTY',
    name: 'Booty',
    color: '#00b4f4'
  },
  BOS: {
    symbol: 'BOS',
    name: 'BOScoin',
    color: '#00a8d6'
  },
  BPT: {
    symbol: 'BPT',
    name: 'Blockport',
    color: '#0f63d8'
  },
  BQ: {
    symbol: 'BQ',
    name: 'bitqy',
    color: '#1d1d1d'
  },
  BRD: {
    symbol: 'BRD',
    name: 'Bread',
    color: '#fe5d86'
  },
  BSD: {
    symbol: 'BSD',
    name: 'BitSend',
    color: '#000000'
  },
  BSV: {
    symbol: 'BSV',
    name: 'BitcoinSV',
    color: '#eab304'
  },
  BTC: {
    symbol: 'BTC',
    name: 'Bitcoin',
    color: '#f7931a'
  },
  BTCD: {
    symbol: 'BTCD',
    name: 'BitcoinDark',
    color: '#ff6600'
  },
  BTCH: {
    symbol: 'BTCH',
    name: 'Bitcoin Hush',
    color: '#4700c2'
  },
  BTCP: {
    symbol: 'BTCP',
    name: 'Bitcoin Private',
    color: '#272d63'
  },
  BTCZ: {
    symbol: 'BTCZ',
    name: 'BitcoinZ',
    color: '#f8c24a'
  },
  BTDX: {
    symbol: 'BTDX',
    name: 'Bitcloud',
    color: '#00aaff'
  },
  BTG: {
    symbol: 'BTG',
    name: 'Bitcoin Gold',
    color: '#eba809'
  },
  BTM: {
    symbol: 'BTM',
    name: 'Bytom',
    color: '#504c4c'
  },
  BTS: {
    symbol: 'BTS',
    name: 'BitShares',
    color: '#35baeb'
  },
  BTT: {
    symbol: 'BTT',
    name: 'BitTorrent',
    color: '#000000'
  },
  BTX: {
    symbol: 'BTX',
    name: 'Bitcore',
    color: '#fb2ea3'
  },
  BURST: {
    symbol: 'BURST',
    name: 'Burst',
    color: '#2d2d2d'
  },
  BZE: {
    symbol: 'BZE',
    name: 'BZEdge',
    color: '#00aeef'
  },
  CALL: {
    symbol: 'CALL',
    name: 'Capital',
    color: '#fbb413'
  },
  CC: {
    symbol: 'CC',
    name: 'CoinCollect',
    color: '#36b0f3'
  },
  CDN: {
    symbol: 'CDN',
    name: 'Canada eCoin',
    color: '#f70808'
  },
  CDT: {
    symbol: 'CDT',
    name: 'Blox',
    color: '#272731'
  },
  CHAIN: {
    symbol: 'CHAIN',
    name: 'Chainmakers',
    color: '#00aced'
  },
  CHAT: {
    symbol: 'CHAT',
    name: 'ChatCoin',
    color: '#1c98f7'
  },
  CHIPS: {
    symbol: 'CHIPS',
    name: 'CHIPS',
    color: '#598182'
  },
  CHSB: {
    symbol: 'CHSB',
    name: 'SwissBorg',
    color: '#01c38d'
  },
  CIX: {
    symbol: 'CIX',
    name: 'Cryptonetix',
    color: '#0576b4'
  },
  CLAM: {
    symbol: 'CLAM',
    name: 'Clams',
    color: '#20c5d3'
  },
  CLOAK: {
    symbol: 'CLOAK',
    name: 'Cloakcoin',
    color: '#ff3a00'
  },
  CMM: {
    symbol: 'CMM',
    name: 'Commercium',
    color: '#2fd2e5'
  },
  CMT: {
    symbol: 'CMT',
    name: 'Comet',
    color: '#c1a05c'
  },
  CND: {
    symbol: 'CND',
    name: 'Cindicator',
    color: '#383939'
  },
  CNX: {
    symbol: 'CNX',
    name: 'Cryptonex',
    color: '#4c6bae'
  },
  CNY: {
    symbol: 'CNY',
    name: 'CNY',
    color: '#ff4314'
  },
  COB: {
    symbol: 'COB',
    name: 'Cobinhood',
    color: '#13bf99'
  },
  COLX: {
    symbol: 'COLX',
    name: 'ColossusXT',
    color: '#77c3b0'
  },
  COMP: {
    symbol: 'COMP',
    name: 'Compound',
    color: '#00d395'
  },
  COQUI: {
    symbol: 'COQUI',
    name: 'COQUI Cash',
    color: '#71c800'
  },
  CRED: {
    symbol: 'CRED',
    name: 'Verify',
    color: '#37e8a3'
  },
  CRPT: {
    symbol: 'CRPT',
    name: 'Crypterium',
    color: '#00bdcd'
  },
  CRV: {
    symbol: 'CRV',
    name: 'Curve DAO Token',
    color: '#40649f'
  },
  CRW: {
    symbol: 'CRW',
    name: 'Crown',
    color: '#0f1529'
  },
  CS: {
    symbol: 'CS',
    name: 'CREDITS',
    color: '#262626'
  },
  CTR: {
    symbol: 'CTR',
    name: 'Centra',
    color: '#fdde6c'
  },
  CTXC: {
    symbol: 'CTXC',
    name: 'Cortex',
    color: '#000000'
  },
  CVC: {
    symbol: 'CVC',
    name: 'Civic',
    color: '#3ab03e'
  },
  D: {
    symbol: 'D',
    name: 'Denarius',
    color: '#b8b8b8'
  },
  DAI: {
    symbol: 'DAI',
    name: 'Dai',
    color: '#f4b731'
  },
  DASH: {
    symbol: 'DASH',
    name: 'Dash',
    color: '#008ce7'
  },
  DAT: {
    symbol: 'DAT',
    name: 'Datum',
    color: '#2d9cdb'
  },
  DATA: {
    symbol: 'DATA',
    name: 'Streamr DATAcoin',
    color: '#e9570f'
  },
  DBC: {
    symbol: 'DBC',
    name: 'DeepBrain Chain',
    color: '#5bc1d4'
  },
  DCN: {
    symbol: 'DCN',
    name: 'Dentacoin',
    color: '#136485'
  },
  DCR: {
    symbol: 'DCR',
    name: 'Decred',
    color: '#2ed6a1'
  },
  DEEZ: {
    symbol: 'DEEZ',
    name: 'DeezNuts',
    color: '#939393'
  },
  DERO: {
    symbol: 'DERO',
    name: 'Dero',
    color: '#ffffff'
  },
  DENT: {
    symbol: 'DENT',
    name: 'Dent',
    color: '#666666'
  },
  DEW: {
    symbol: 'DEW',
    name: 'DEW',
    color: '#fec907'
  },
  DGB: {
    symbol: 'DGB',
    name: 'DigiByte',
    color: '#006ad2'
  },
  DGD: {
    symbol: 'DGD',
    name: 'DigixDAO',
    color: '#f4d029'
  },
  DLT: {
    symbol: 'DLT',
    name: 'Agrello',
    color: '#f4ae95'
  },
  DNT: {
    symbol: 'DNT',
    name: 'district0x',
    color: '#2c398f'
  },
  DOCK: {
    symbol: 'DOCK',
    name: 'Dock',
    color: '#786dbc'
  },
  DOGE: {
    symbol: 'DOGE',
    name: 'Dogecoin',
    color: '#c3a634'
  },
  DOT: {
    symbol: 'DOT',
    name: 'Polkadot',
    color: '#e6007a'
  },
  DRGN: {
    symbol: 'DRGN',
    name: 'Dragonchain',
    color: '#c91111'
  },
  DROP: {
    symbol: 'DROP',
    name: 'Dropil',
    color: '#242d3d'
  },
  DTA: {
    symbol: 'DTA',
    name: 'DATA',
    color: '#74d269'
  },
  DTH: {
    symbol: 'DTH',
    name: 'Dether',
    color: '#3c80f1'
  },
  DTR: {
    symbol: 'DTR',
    name: 'Dynamic Trading Rights',
    color: '#121747'
  },
  EBST: {
    symbol: 'EBST',
    name: 'eBoost',
    color: '#1693d4'
  },
  ECA: {
    symbol: 'ECA',
    name: 'Electra',
    color: '#aa15dd'
  },
  EDG: {
    symbol: 'EDG',
    name: 'Edgeless',
    color: '#2b1544'
  },
  EDO: {
    symbol: 'EDO',
    name: 'Eidoo',
    color: '#242424'
  },
  EDOGE: {
    symbol: 'EDOGE',
    name: 'EtherDoge',
    color: '#0facf3'
  },
  ELA: {
    symbol: 'ELA',
    name: 'Elastos',
    color: '#3fbadf'
  },
  ELEC: {
    symbol: 'ELEC',
    name: 'Electrify.Asia',
    color: '#ff9900'
  },
  ELF: {
    symbol: 'ELF',
    name: 'aelf',
    color: '#2b5ebb'
  },
  ELIX: {
    symbol: 'ELIX',
    name: 'Elixir',
    color: '#00aded'
  },
  ELLA: {
    symbol: 'ELLA',
    name: 'Ellaism',
    color: '#396a28'
  },
  EMB: {
    symbol: 'EMB',
    name: 'Emblem',
    color: '#f6c054'
  },
  EMC: {
    symbol: 'EMC',
    name: 'EmerCoin',
    color: '#b49ffc'
  },
  EMC2: {
    symbol: 'EMC2',
    name: 'Einsteinium',
    color: '#00ccff'
  },
  ENG: {
    symbol: 'ENG',
    name: 'Enigma',
    color: '#2f2f2f'
  },
  ENJ: {
    symbol: 'ENJ',
    name: 'Enjin Coin',
    color: '#624dbf'
  },
  ENTRP: {
    symbol: 'ENTRP',
    name: 'Hut34 Entropy',
    color: '#fa5836'
  },
  EON: {
    symbol: 'EON',
    name: 'EOS Network',
    color: '#443f54'
  },
  EOP: {
    symbol: 'EOP',
    name: 'EOP',
    color: '#35a7df'
  },
  EOS: {
    symbol: 'EOS',
    name: 'EOS',
    color: '#000000'
  },
  EQLI: {
    symbol: 'EQLI',
    name: 'Equaliser',
    color: '#c9a35e'
  },
  EQUA: {
    symbol: 'EQUA',
    name: 'EQUA',
    color: '#f68922'
  },
  ETC: {
    symbol: 'ETC',
    name: 'Ethereum Classic',
    color: '#328332'
  },
  ETH: {
    symbol: 'ETH',
    name: 'Ethereum',
    color: '#627eea'
  },
  ETHOS: {
    symbol: 'ETHOS',
    name: 'Ethos',
    color: '#00ffba'
  },
  ETN: {
    symbol: 'ETN',
    name: 'Electroneum',
    color: '#23bee2'
  },
  ETP: {
    symbol: 'ETP',
    name: 'Metaverse ETP',
    color: '#00a5ff'
  },
  EUR: {
    symbol: 'EUR',
    name: 'EUR',
    color: '#0f8ff8'
  },
  EVX: {
    symbol: 'EVX',
    name: 'Everex',
    color: '#044aac'
  },
  EXMO: {
    symbol: 'EXMO',
    name: 'EXMO',
    color: '#347ffb'
  },
  EXP: {
    symbol: 'EXP',
    name: 'Expanse',
    color: '#ffaa5c'
  },
  FAIR: {
    symbol: 'FAIR',
    name: 'Faircoin',
    color: '#c99705'
  },
  FCT: {
    symbol: 'FCT',
    name: 'Factom',
    color: '#417ba4'
  },
  FIL: {
    symbol: 'FIL',
    name: 'Filecoin [IOU]',
    color: '#42c1ca'
  },
  FJC: {
    symbol: 'FJC',
    name: 'Fujicoin',
    color: '#00afec'
  },
  FLDC: {
    symbol: 'FLDC',
    name: 'Foldingcoin',
    color: '#c40e09'
  },
  FLO: {
    symbol: 'FLO',
    name: 'FLO',
    color: '#2080a2'
  },
  FLUX: {
    symbol: 'FLUX',
    name: 'Flux',
    color: '#2b61d1'
  },
  FSN: {
    symbol: 'FSN',
    name: 'FUSION',
    color: '#1d9ad7'
  },
  FTC: {
    symbol: 'FTC',
    name: 'Feathercoin',
    color: '#27323a'
  },
  FUEL: {
    symbol: 'FUEL',
    name: 'Etherparty',
    color: '#4096d0'
  },
  FUN: {
    symbol: 'FUN',
    name: 'FunFair',
    color: '#ed1968'
  },
  GAME: {
    symbol: 'GAME',
    name: 'GameCredits',
    color: '#2d475b'
  },
  GAS: {
    symbol: 'GAS',
    name: 'Gas',
    color: '#58bf00'
  },
  GBP: {
    symbol: 'GBP',
    name: 'GBP',
    color: '#bc3fe0'
  },
  GBX: {
    symbol: 'GBX',
    name: 'Globitex',
    color: '#1666af'
  },
  GBYTE: {
    symbol: 'GBYTE',
    name: 'Obyte',
    color: '#302c2c'
  },
  GENERIC: {
    symbol: 'GENERIC',
    name: 'GENERIC',
    color: '#efb914'
  },
  GIN: {
    symbol: 'GIN',
    name: 'GINcoin',
    color: '#008dde'
  },
  GLXT: {
    symbol: 'GLXT',
    name: 'GLX Token',
    color: '#005396'
  },
  GMR: {
    symbol: 'GMR',
    name: 'Gimmer',
    color: '#372d2c'
  },
  GNO: {
    symbol: 'GNO',
    name: 'Gnosis',
    color: '#00a6c4'
  },
  GNT: {
    symbol: 'GNT',
    name: 'Golem',
    color: '#001d57'
  },
  GOLD: {
    symbol: 'GOLD',
    name: 'Dragonereum Gold',
    color: '#f1b32b'
  },
  GRC: {
    symbol: 'GRC',
    name: 'Gridcoin',
    color: '#5411b3'
  },
  GRIN: {
    symbol: 'GRIN',
    name: 'Grin',
    color: '#fff300'
  },
  GRS: {
    symbol: 'GRS',
    name: 'Groestlcoin',
    color: '#377e96'
  },
  GRT: {
    symbol: 'GRT',
    name: 'The Graph',
    color: '#5942cc'
  },
  GSC: {
    symbol: 'GSC',
    name: 'Global Social Chain',
    color: '#ff0060'
  },
  GTO: {
    symbol: 'GTO',
    name: 'Gifto',
    color: '#7f27ff'
  },
  GUP: {
    symbol: 'GUP',
    name: 'Guppy',
    color: '#37dcd8'
  },
  GUSD: {
    symbol: 'GUSD',
    name: 'Gemini dollar',
    color: '#00dcfa'
  },
  GVT: {
    symbol: 'GVT',
    name: 'Genesis Vision',
    color: '#16b9ad'
  },
  GXS: {
    symbol: 'GXS',
    name: 'GXChain',
    color: '#35a5f3'
  },
  GZR: {
    symbol: 'GZR',
    name: 'Gizer',
    color: '#56c9e9'
  },
  HIGHT: {
    symbol: 'HIGHT',
    name: 'Highcoin',
    color: '#117fc0'
  },
  HNS: {
    symbol: 'HNS',
    name: 'Handshake',
    color: '#000000'
  },
  HODL: {
    symbol: 'HODL',
    name: 'HOdlcoin',
    color: '#d59143'
  },
  HOT: {
    symbol: 'HOT',
    name: 'Holo',
    color: '#8834ff'
  },
  HPB: {
    symbol: 'HPB',
    name: 'High Performance Blockchain',
    color: '#1591ca'
  },
  HSR: {
    symbol: 'HSR',
    name: 'HShare',
    color: '#56428e'
  },
  HT: {
    symbol: 'HT',
    name: 'HOTTO',
    color: '#2a3069'
  },
  HTR: {
    symbol: 'HTR',
    name: 'Hathor',
    color: '#ffffff'
  },
  HTML: {
    symbol: 'HTML',
    name: 'HTMLCOIN',
    color: '#cfa967'
  },
  HUC: {
    symbol: 'HUC',
    name: 'Huntercoin',
    color: '#ffc018'
  },
  HUSD: {
    symbol: 'HUSD',
    name: 'HUSD',
    color: '#005ffa'
  },
  HUSH: {
    symbol: 'HUSH',
    name: 'Hush',
    color: '#292929'
  },
  ICN: {
    symbol: 'ICN',
    name: 'Iconomi',
    color: '#4c6f8c'
  },
  ICP: {
    symbol: 'ICP',
    name: 'Internet Computer',
    color: '#292a2e'
  },
  ICX: {
    symbol: 'ICX',
    name: 'ICON',
    color: '#1fc5c9'
  },
  IGNIS: {
    symbol: 'IGNIS',
    name: 'Ignis',
    color: '#f9c011'
  },
  ILK: {
    symbol: 'ILK',
    name: 'Inlock Token',
    color: '#98c23a'
  },
  INK: {
    symbol: 'INK',
    name: 'Ink',
    color: '#df1a14'
  },
  INS: {
    symbol: 'INS',
    name: 'Insolar',
    color: '#b2a3f6'
  },
  ION: {
    symbol: 'ION',
    name: 'ION',
    color: '#57beea'
  },
  IOP: {
    symbol: 'IOP',
    name: 'Internet of People',
    color: '#0cafa5'
  },
  IOST: {
    symbol: 'IOST',
    name: 'IOStoken',
    color: '#1c1c1c'
  },
  IOTX: {
    symbol: 'IOTX',
    name: 'IoTeX',
    color: '#00d4d5'
  },
  IQ: {
    symbol: 'IQ',
    name: 'Everipedia',
    color: '#55ddff'
  },
  ITC: {
    symbol: 'ITC',
    name: 'IoT Chain',
    color: '#102044'
  },
  JNT: {
    symbol: 'JNT',
    name: 'Jibrel Network',
    color: '#0050db'
  },
  JPY: {
    symbol: 'JPY',
    name: 'JPY',
    color: '#eac749'
  },
  KCS: {
    symbol: 'KCS',
    name: 'KuCoin Shares',
    color: '#0093dd'
  },
  KIN: {
    symbol: 'KIN',
    name: 'Kin',
    color: '#005fff'
  },
  KLOWN: {
    symbol: 'KLOWN',
    name: 'Ether Clown',
    color: '#ea0017'
  },
  KMD: {
    symbol: 'KMD',
    name: 'Komodo',
    color: '#2b6680'
  },
  KNC: {
    symbol: 'KNC',
    name: 'Kyber Network',
    color: '#31cb9e'
  },
  KRB: {
    symbol: 'KRB',
    name: 'Karbo',
    color: '#00aeef'
  },
  KSM: {
    symbol: 'KSM',
    name: 'Kusama',
    color: '#000000'
  },
  LBC: {
    symbol: 'LBC',
    name: 'LBRY Credits',
    color: '#006149'
  },
  LEND: {
    symbol: 'LEND',
    name: 'ETHLend',
    color: '#0fa9c9'
  },
  LEO: {
    symbol: 'LEO',
    name: 'Unus Sed LEO',
    color: '#11021e'
  },
  LINK: {
    symbol: 'LINK',
    name: 'ChainLink',
    color: '#2a5ada'
  },
  LKK: {
    symbol: 'LKK',
    name: 'Lykke',
    color: '#9d01eb'
  },
  LOOM: {
    symbol: 'LOOM',
    name: 'Loom Network',
    color: '#48beff'
  },
  LPT: {
    symbol: 'LPT',
    name: 'Livepeer Token',
    color: '#000000'
  },
  LRC: {
    symbol: 'LRC',
    name: 'Loopring',
    color: '#2ab6f6'
  },
  LSK: {
    symbol: 'LSK',
    name: 'Lisk',
    color: '#0d4ea0'
  },
  LTC: {
    symbol: 'LTC',
    name: 'Litecoin',
    color: '#bfbbbb'
  },
  LUN: {
    symbol: 'LUN',
    name: 'Lunyr',
    color: '#f55749'
  },
  MAID: {
    symbol: 'MAID',
    name: 'MaidSafeCoin',
    color: '#5592d7'
  },
  MANA: {
    symbol: 'MANA',
    name: 'Decentraland',
    color: '#ff2d55'
  },
  MATIC: {
    symbol: 'MATIC',
    name: 'Polygon',
    color: '#6f41d8'
  },
  MAX: {
    symbol: 'MAX',
    name: 'MAX Token',
    color: '#2d4692'
  },
  MCAP: {
    symbol: 'MCAP',
    name: 'MCAP',
    color: '#033b4a'
  },
  MCO: {
    symbol: 'MCO',
    name: 'Crypto.com',
    color: '#103f68'
  },
  MDA: {
    symbol: 'MDA',
    name: 'Moeda Loyalty Points',
    color: '#01a64f'
  },
  MDS: {
    symbol: 'MDS',
    name: 'MediShares',
    color: '#1e252c'
  },
  MED: {
    symbol: 'MED',
    name: 'Medibloc',
    color: '#00b0ff'
  },
  MEETONE: {
    symbol: 'MEETONE',
    name: 'MEET.ONE',
    color: '#000000'
  },
  MFT: {
    symbol: 'MFT',
    name: 'Mainframe',
    color: '#da1157'
  },
  MIOTA: {
    symbol: 'MIOTA',
    name: 'IOTA',
    color: '#242424'
  },
  MITH: {
    symbol: 'MITH',
    name: 'Mithril',
    color: '#00316d'
  },
  MKR: {
    symbol: 'MKR',
    name: 'Maker',
    color: '#1aab9b'
  },
  MLN: {
    symbol: 'MLN',
    name: 'Melon',
    color: '#0b1529'
  },
  MNX: {
    symbol: 'MNX',
    name: 'MinexCoin',
    color: '#00adef'
  },
  MNZ: {
    symbol: 'MNZ',
    name: 'MNZ',
    color: '#7f368a'
  },
  MOAC: {
    symbol: 'MOAC',
    name: 'MOAC',
    color: '#000000'
  },
  MOD: {
    symbol: 'MOD',
    name: 'Modum',
    color: '#09547d'
  },
  MONA: {
    symbol: 'MONA',
    name: 'MonaCoin',
    color: '#dec799'
  },
  MSR: {
    symbol: 'MSR',
    name: 'Masari',
    color: '#47b95c'
  },
  MTH: {
    symbol: 'MTH',
    name: 'Monetha',
    color: '#104fca'
  },
  MTL: {
    symbol: 'MTL',
    name: 'Metal',
    color: '#1e1f25'
  },
  MUSIC: {
    symbol: 'MUSIC',
    name: 'Musicoin',
    color: '#ffffff'
  },
  MZC: {
    symbol: 'MZC',
    name: 'MAZA',
    color: '#ffaa05'
  },
  NANO: {
    symbol: 'NANO',
    name: 'Nano',
    color: '#4a90e2'
  },
  NAS: {
    symbol: 'NAS',
    name: 'Nebulas',
    color: '#222222'
  },
  NAV: {
    symbol: 'NAV',
    name: 'NavCoin',
    color: '#7d59b5'
  },
  NCASH: {
    symbol: 'NCASH',
    name: 'Nucleus Vision',
    color: '#36a9cf'
  },
  NDZ: {
    symbol: 'NDZ',
    name: 'NDZ',
    color: '#622fba'
  },
  NEBL: {
    symbol: 'NEBL',
    name: 'Neblio',
    color: '#50479e'
  },
  NEO: {
    symbol: 'NEO',
    name: 'NEO',
    color: '#58bf00'
  },
  NEOS: {
    symbol: 'NEOS',
    name: 'Neoscoin',
    color: '#e5f300'
  },
  NEU: {
    symbol: 'NEU',
    name: 'Neumark',
    color: '#b3ba00'
  },
  NEXO: {
    symbol: 'NEXO',
    name: 'Nexo',
    color: '#1a4199'
  },
  NGC: {
    symbol: 'NGC',
    name: 'NAGA',
    color: '#f80000'
  },
  NIO: {
    symbol: 'NIO',
    name: 'Autonio',
    color: '#70c9c9'
  },
  NKN: {
    symbol: 'NKN',
    name: 'NKN',
    color: '#23336f'
  },
  NLC2: {
    symbol: 'NLC2',
    name: 'NoLimitCoin',
    color: '#f28f01'
  },
  NLG: {
    symbol: 'NLG',
    name: 'Gulden',
    color: '#2ab0fd'
  },
  NMC: {
    symbol: 'NMC',
    name: 'Namecoin',
    color: '#186c9d'
  },
  NMR: {
    symbol: 'NMR',
    name: 'Numeraire',
    color: '#050708'
  },
  NPXS: {
    symbol: 'NPXS',
    name: 'Pundi X',
    color: '#f5d100'
  },
  NTBC: {
    symbol: 'NTBC',
    name: 'Note Blockchain',
    color: '#eec315'
  },
  NULS: {
    symbol: 'NULS',
    name: 'Nuls',
    color: '#82bd39'
  },
  NXS: {
    symbol: 'NXS',
    name: 'Nexus',
    color: '#4099cd'
  },
  NXT: {
    symbol: 'NXT',
    name: 'NXT',
    color: '#008fbb'
  },
  OAX: {
    symbol: 'OAX',
    name: 'OpenANX',
    color: '#164b79'
  },
  OK: {
    symbol: 'OK',
    name: 'OKCash',
    color: '#000000'
  },
  OMG: {
    symbol: 'OMG',
    name: 'OMG Network',
    color: '#101010'
  },
  OMNI: {
    symbol: 'OMNI',
    name: 'Omni',
    color: '#1c347a'
  },
  ONE: {
    symbol: 'ONE',
    name: 'Harmony',
    color: '#00aee9'
  },
  ONG: {
    symbol: 'ONG',
    name: 'SoMee.Social',
    color: '#000000'
  },
  ONT: {
    symbol: 'ONT',
    name: 'Ontology',
    color: '#32a4be'
  },
  OOT: {
    symbol: 'OOT',
    name: 'Utrum',
    color: '#25aae1'
  },
  OST: {
    symbol: 'OST',
    name: 'OST',
    color: '#34445b'
  },
  OX: {
    symbol: 'OX',
    name: 'OX Fina',
    color: '#4392cd'
  },
  OXT: {
    symbol: 'OXT',
    name: 'Orchid',
    color: '#5f45ba'
  },
  PART: {
    symbol: 'PART',
    name: 'Particl',
    color: '#65cb8d'
  },
  PASC: {
    symbol: 'PASC',
    name: 'Pascalcoin',
    color: '#f7931e'
  },
  PASL: {
    symbol: 'PASL',
    name: 'Pascal Lite',
    color: '#00acff'
  },
  PAX: {
    symbol: 'PAX',
    name: 'PAX Token',
    color: '#398260'
  },
  PAXG: {
    symbol: 'PAXG',
    name: 'PAX Gold',
    color: '#e4ce4d'
  },
  PAY: {
    symbol: 'PAY',
    name: 'TenX',
    color: '#302c2c'
  },
  PAYX: {
    symbol: 'PAYX',
    name: 'Paypex',
    color: '#663300'
  },
  PINK: {
    symbol: 'PINK',
    name: 'Pinkcoin',
    color: '#ed79aa'
  },
  PIRL: {
    symbol: 'PIRL',
    name: 'Pirl',
    color: '#96b73d'
  },
  PIVX: {
    symbol: 'PIVX',
    name: 'PIVX',
    color: '#5e4778'
  },
  PLR: {
    symbol: 'PLR',
    name: 'Pillar',
    color: '#00bfff'
  },
  POA: {
    symbol: 'POA',
    name: 'POA Network',
    color: '#444fa1'
  },
  POE: {
    symbol: 'POE',
    name: 'Po.et',
    color: '#dcd6cc'
  },
  POLIS: {
    symbol: 'POLIS',
    name: 'Polis',
    color: '#2c3e50'
  },
  POLY: {
    symbol: 'POLY',
    name: 'Polymath Network',
    color: '#4c5a95'
  },
  POT: {
    symbol: 'POT',
    name: 'Potcoin',
    color: '#105b2f'
  },
  POWR: {
    symbol: 'POWR',
    name: 'Power Ledger',
    color: '#05bca9'
  },
  PPC: {
    symbol: 'PPC',
    name: 'Peercoin',
    color: '#3cb054'
  },
  PPP: {
    symbol: 'PPP',
    name: 'PayPie',
    color: '#348f8d'
  },
  PPT: {
    symbol: 'PPT',
    name: 'Populous',
    color: '#152743'
  },
  PRE: {
    symbol: 'PRE',
    name: 'Presearch',
    color: '#3a8cbd'
  },
  PRL: {
    symbol: 'PRL',
    name: 'Oyster',
    color: '#1061e3'
  },
  PUNGO: {
    symbol: 'PUNGO',
    name: 'Pungo Token',
    color: '#22b573'
  },
  PURA: {
    symbol: 'PURA',
    name: 'Pura',
    color: '#333333'
  },
  QASH: {
    symbol: 'QASH',
    name: 'QASH',
    color: '#1347e8'
  },
  QIWI: {
    symbol: 'QIWI',
    name: 'QIWI',
    color: '#ff8c00'
  },
  QLC: {
    symbol: 'QLC',
    name: 'QLC Chain',
    color: '#610089'
  },
  QRL: {
    symbol: 'QRL',
    name: 'Quantum Resistant Ledger',
    color: '#252525'
  },
  QSP: {
    symbol: 'QSP',
    name: 'Quantstamp',
    color: '#454545'
  },
  QTUM: {
    symbol: 'QTUM',
    name: 'Qtum',
    color: '#2e9ad0'
  },
  R: {
    symbol: 'R',
    name: 'Revain',
    color: '#771a4e'
  },
  RADS: {
    symbol: 'RADS',
    name: 'Radium',
    color: '#9d4bef'
  },
  RAP: {
    symbol: 'RAP',
    name: 'Rapture',
    color: '#000000'
  },
  RCN: {
    symbol: 'RCN',
    name: 'Rcoin',
    color: '#3555f9'
  },
  RDD: {
    symbol: 'RDD',
    name: 'Reddcoin',
    color: '#e30613'
  },
  RDN: {
    symbol: 'RDN',
    name: 'Raiden Network Token',
    color: '#2a2a2a'
  },
  REN: {
    symbol: 'REN',
    name: 'Ren',
    color: '#080817'
  },
  REP: {
    symbol: 'REP',
    name: 'Augur',
    color: '#602a52'
  },
  REPV2: {
    symbol: 'REPV2',
    name: 'Augur',
    color: '#0e0e21'
  },
  REQ: {
    symbol: 'REQ',
    name: 'Request',
    color: '#00e6a0'
  },
  RHOC: {
    symbol: 'RHOC',
    name: 'RChain',
    color: '#cc1e46'
  },
  RIC: {
    symbol: 'RIC',
    name: 'Riecoin',
    color: '#60e4dd'
  },
  RISE: {
    symbol: 'RISE',
    name: 'Rise',
    color: '#f49352'
  },
  RLC: {
    symbol: 'RLC',
    name: 'iExec RLC',
    color: '#ffd800'
  },
  RPX: {
    symbol: 'RPX',
    name: 'RPX',
    color: '#8d181b'
  },
  RUB: {
    symbol: 'RUB',
    name: 'RUB',
    color: '#64d1ff'
  },
  RVN: {
    symbol: 'RVN',
    name: 'Ravencoin',
    color: '#384182'
  },
  RYO: {
    symbol: 'RYO',
    name: 'Ryo Currency',
    color: '#3d58b0'
  },
  SAFE: {
    symbol: 'SAFE',
    name: 'Safe',
    color: '#00688c'
  },
  SAFEMOON: {
    symbol: 'SAFEMOON',
    name: 'SafeMoon',
    color: '#00a79d'
  },
  SAI: {
    symbol: 'SAI',
    name: 'Single Collateral DAI',
    color: '#b68900'
  },
  SALT: {
    symbol: 'SALT',
    name: 'SALT',
    color: '#1beef4'
  },
  SAN: {
    symbol: 'SAN',
    name: 'Santiment Network Token',
    color: '#2b77b3'
  },
  SAND: {
    symbol: 'SAND',
    name: 'The Sandbox',
    color: '#04adef'
  },
  SBD: {
    symbol: 'SBD',
    name: 'Steem Dollars',
    color: '#4ba2f2'
  },
  SBERBANK: {
    symbol: 'SBERBANK',
    name: 'SBERBANK',
    color: '#48b254'
  },
  SC: {
    symbol: 'SC',
    name: 'Siacoin',
    color: '#20ee82'
  },
  SHIFT: {
    symbol: 'SHIFT',
    name: 'Shift',
    color: '#964b9c'
  },
  SIB: {
    symbol: 'SIB',
    name: 'SIBCoin',
    color: '#057bc1'
  },
  SIN: {
    symbol: 'SIN',
    name: 'SINOVATE',
    color: '#f5342e'
  },
  SKL: {
    symbol: 'SKL',
    name: 'SKALE Network',
    color: '#000000'
  },
  SKY: {
    symbol: 'SKY',
    name: 'Skycoin',
    color: '#0072ff'
  },
  SLR: {
    symbol: 'SLR',
    name: 'Solarcoin',
    color: '#fda616'
  },
  SLS: {
    symbol: 'SLS',
    name: 'SaluS',
    color: '#8e9495'
  },
  SMART: {
    symbol: 'SMART',
    name: 'SmartCash',
    color: '#fec60d'
  },
  SNGLS: {
    symbol: 'SNGLS',
    name: 'SingularDTV',
    color: '#b30d23'
  },
  SNM: {
    symbol: 'SNM',
    name: 'SONM',
    color: '#0b1c26'
  },
  SNT: {
    symbol: 'SNT',
    name: 'Status',
    color: '#5b6dee'
  },
  SNX: {
    symbol: 'SNX',
    name: 'Synthetix',
    color: '#5fcdf9'
  },
  SOC: {
    symbol: 'SOC',
    name: 'All Sports',
    color: '#199248'
  },
  SOL: {
    symbol: 'SOL',
    name: 'Solana',
    color: '#66f9a1'
  },
  SPACEHBIT: {
    symbol: 'SPACEHBIT',
    name: 'HashBit Blockchain',
    color: '#0971fe'
  },
  SPANK: {
    symbol: 'SPANK',
    name: 'SpankChain',
    color: '#ff3b81'
  },
  SPHTX: {
    symbol: 'SPHTX',
    name: 'SophiaTX',
    color: '#00b098'
  },
  SRN: {
    symbol: 'SRN',
    name: 'Sirin Labs Token',
    color: '#1c1c1c'
  },
  STAK: {
    symbol: 'STAK',
    name: 'STRAKS',
    color: '#f2941b'
  },
  START: {
    symbol: 'START',
    name: 'Startcoin',
    color: '#01aef0'
  },
  STEEM: {
    symbol: 'STEEM',
    name: 'Steem',
    color: '#4ba2f2'
  },
  STORJ: {
    symbol: 'STORJ',
    name: 'Storj',
    color: '#2683ff'
  },
  STORM: {
    symbol: 'STORM',
    name: 'Storm',
    color: '#080d98'
  },
  STOX: {
    symbol: 'STOX',
    name: 'Stox',
    color: '#7324f0'
  },
  STQ: {
    symbol: 'STQ',
    name: 'Storiqa',
    color: '#2dc4e7'
  },
  STRAT: {
    symbol: 'STRAT',
    name: 'Stratis',
    color: '#1387c9'
  },
  STX: {
    symbol: 'STX',
    name: 'Stacks',
    color: '#5546ff'
  },
  SUB: {
    symbol: 'SUB',
    name: 'Substratum',
    color: '#e53431'
  },
  SUMO: {
    symbol: 'SUMO',
    name: 'Sumokoin',
    color: '#2d9cdb'
  },
  SUSHI: {
    symbol: 'SUSHI',
    name: 'SushiSwap',
    color: '#d65892'
  },
  SYS: {
    symbol: 'SYS',
    name: 'Syscoin',
    color: '#0082c6'
  },
  TAAS: {
    symbol: 'TAAS',
    name: 'TaaS',
    color: '#002342'
  },
  TAU: {
    symbol: 'TAU',
    name: 'Lamden',
    color: '#7b346e'
  },
  TBX: {
    symbol: 'TBX',
    name: 'Tokenbox',
    color: '#5244d4'
  },
  TEL: {
    symbol: 'TEL',
    name: 'Telcoin',
    color: '#14c8ff'
  },
  TEN: {
    symbol: 'TEN',
    name: 'Tokenomy',
    color: '#0899cd'
  },
  TERN: {
    symbol: 'TERN',
    name: 'Ternio',
    color: '#f4c257'
  },
  TGCH: {
    symbol: 'TGCH',
    name: 'TrueGalaxyCash',
    color: '#434247'
  },
  THETA: {
    symbol: 'THETA',
    name: 'Theta Network',
    color: '#2ab8e6'
  },
  TIX: {
    symbol: 'TIX',
    name: 'Blocktix',
    color: '#ef494d'
  },
  TKN: {
    symbol: 'TKN',
    name: 'TokenCard',
    color: '#24dd7b'
  },
  TKS: {
    symbol: 'TKS',
    name: 'Tokes Platform',
    color: '#895af8'
  },
  TNB: {
    symbol: 'TNB',
    name: 'Time New Bank',
    color: '#ffc04e'
  },
  TNC: {
    symbol: 'TNC',
    name: 'Trinity Network Credit',
    color: '#ff439b'
  },
  TNT: {
    symbol: 'TNT',
    name: 'Tierion',
    color: '#ff4081'
  },
  TOKO: {
    symbol: 'TOKO',
    name: 'Tokoin',
    color: '#ffffff'
  },
  TOMO: {
    symbol: 'TOMO',
    name: 'TomoChain',
    color: '#1a1f36'
  },
  TPAY: {
    symbol: 'TPAY',
    name: 'TokenPay',
    color: '#3058a6'
  },
  TRIG: {
    symbol: 'TRIG',
    name: 'Triggers',
    color: '#30c0f2'
  },
  TRTL: {
    symbol: 'TRTL',
    name: 'TurtleCoin',
    color: '#00843d'
  },
  TRX: {
    symbol: 'TRX',
    name: 'TRON',
    color: '#ef0027'
  },
  TUSD: {
    symbol: 'TUSD',
    name: 'TrueUSD',
    color: '#2b2e7f'
  },
  TZC: {
    symbol: 'TZC',
    name: 'TrezarCoin',
    color: '#374851'
  },
  UBQ: {
    symbol: 'UBQ',
    name: 'Ubiq',
    color: '#00ea90'
  },
  UMA: {
    symbol: 'UMA',
    name: 'UMA',
    color: '#ff4a4a'
  },
  UNI: {
    symbol: 'UNI',
    name: 'Uniswap',
    color: '#ff007a'
  },
  UNITY: {
    symbol: 'UNITY',
    name: 'SuperNET',
    color: '#f58634'
  },
  USD: {
    symbol: 'USD',
    name: 'USD',
    color: '#6cde07'
  },
  USDC: {
    symbol: 'USDC',
    name: 'USD Coin',
    color: '#3e73c4'
  },
  USDT: {
    symbol: 'USDT',
    name: 'Tether',
    color: '#26a17b'
  },
  UTK: {
    symbol: 'UTK',
    name: 'UTRUST',
    color: '#30367a'
  },
  VERI: {
    symbol: 'VERI',
    name: 'Veritaseum',
    color: '#ff9933'
  },
  VET: {
    symbol: 'VET',
    name: 'VeChain',
    color: '#15bdff'
  },
  VIA: {
    symbol: 'VIA',
    name: 'Viacoin',
    color: '#565656'
  },
  VIB: {
    symbol: 'VIB',
    name: 'Viberate',
    color: '#ff1f43'
  },
  VIBE: {
    symbol: 'VIBE',
    name: 'VIBE',
    color: '#338be5'
  },
  VIVO: {
    symbol: 'VIVO',
    name: 'VIVO',
    color: '#408af1'
  },
  VRA: {
    symbol: 'VRA',
    name: 'Verasity',
    color: '#ffffff'
  },
  VRC: {
    symbol: 'VRC',
    name: 'VeriCoin',
    color: '#418bca'
  },
  VRSC: {
    symbol: 'VRSC',
    name: 'VerusCoin',
    color: '#3165d4'
  },
  VTC: {
    symbol: 'VTC',
    name: 'Vertcoin',
    color: '#048657'
  },
  VTHO: {
    symbol: 'VTHO',
    name: 'VeThor Token',
    color: '#2a5284'
  },
  WABI: {
    symbol: 'WABI',
    name: 'Tael',
    color: '#399b32'
  },
  WAN: {
    symbol: 'WAN',
    name: 'Wanchain',
    color: '#136aad'
  },
  WAVES: {
    symbol: 'WAVES',
    name: 'Waves',
    color: '#0155ff'
  },
  WAX: {
    symbol: 'WAX',
    name: 'WAX',
    color: '#f89022'
  },
  WBTC: {
    symbol: 'WBTC',
    name: 'Wrapped Bitcoin',
    color: '#201a2d'
  },
  WGR: {
    symbol: 'WGR',
    name: 'Wagerr',
    color: '#b80000'
  },
  WICC: {
    symbol: 'WICC',
    name: 'WaykiChain',
    color: '#5783cb'
  },
  WINGS: {
    symbol: 'WINGS',
    name: 'Wings',
    color: '#0dc9f7'
  },
  WPR: {
    symbol: 'WPR',
    name: 'WePower',
    color: '#ffe600'
  },
  WTC: {
    symbol: 'WTC',
    name: 'Waltonchain',
    color: '#8200ff'
  },
  X: {
    symbol: 'X',
    name: 'GLX Equity Token',
    color: '#3b5998'
  },
  XAS: {
    symbol: 'XAS',
    name: 'Asch',
    color: '#faa00d'
  },
  XBC: {
    symbol: 'XBC',
    name: 'Bitcoin Plus',
    color: '#f7931a'
  },
  XBP: {
    symbol: 'XBP',
    name: 'BlitzPredict',
    color: '#21af67'
  },
  XBY: {
    symbol: 'XBY',
    name: 'XtraBYtes',
    color: '#56f4f1'
  },
  XCP: {
    symbol: 'XCP',
    name: 'Counterparty',
    color: '#ed1650'
  },
  XDN: {
    symbol: 'XDN',
    name: 'DigitalNote',
    color: '#4f7aa2'
  },
  XEM: {
    symbol: 'XEM',
    name: 'NEM',
    color: '#67b2e8'
  },
  XIN: {
    symbol: 'XIN',
    name: 'Infinity Economics',
    color: '#1eb5fa'
  },
  XLM: {
    symbol: 'XLM',
    name: 'Stellar',
    color: '#000000'
  },
  XMCC: {
    symbol: 'XMCC',
    name: 'Monoeci',
    color: '#dd0632'
  },
  XMG: {
    symbol: 'XMG',
    name: 'Magi',
    color: '#004a80'
  },
  XMO: {
    symbol: 'XMO',
    name: 'Monero Original',
    color: '#ff6600'
  },
  XMR: {
    symbol: 'XMR',
    name: 'Monero',
    color: '#ff6600'
  },
  XMY: {
    symbol: 'XMY',
    name: 'Myriad',
    color: '#ec1076'
  },
  XP: {
    symbol: 'XP',
    name: 'XP',
    color: '#008200'
  },
  XPA: {
    symbol: 'XPA',
    name: 'XPA',
    color: '#4fa784'
  },
  XPM: {
    symbol: 'XPM',
    name: 'Primecoin',
    color: '#ffd81b'
  },
  XPR: {
    symbol: 'XPR',
    name: 'Proton',
    color: '#7543e3'
  },
  XRP: {
    symbol: 'XRP',
    name: 'XRP',
    color: '#23292f'
  },
  XSG: {
    symbol: 'XSG',
    name: 'SnowGem',
    color: '#d21e2b'
  },
  XTZ: {
    symbol: 'XTZ',
    name: 'Tezos',
    color: '#a6e000'
  },
  XUC: {
    symbol: 'XUC',
    name: 'Exchange Union',
    color: '#25aae3'
  },
  XVC: {
    symbol: 'XVC',
    name: 'Vcash',
    color: '#b50126'
  },
  XVG: {
    symbol: 'XVG',
    name: 'Verge',
    color: '#00cbff'
  },
  XZC: {
    symbol: 'XZC',
    name: 'Zcoin',
    color: '#23b852'
  },
  YFI: {
    symbol: 'YFI',
    name: 'yearn.finance',
    color: '#006ae3'
  },
  YOYOW: {
    symbol: 'YOYOW',
    name: 'YOYOW',
    color: '#21a5de'
  },
  ZCL: {
    symbol: 'ZCL',
    name: 'Zclassic',
    color: '#c87035'
  },
  ZEC: {
    symbol: 'ZEC',
    name: 'Zcash',
    color: '#ecb244'
  },
  ZEL: {
    symbol: 'ZEL',
    name: 'ZelCash',
    color: '#183c87'
  },
  ZEN: {
    symbol: 'ZEN',
    name: 'Horizen',
    color: '#00eaab'
  },
  ZEST: {
    symbol: 'ZEST',
    name: 'Zest',
    color: '#07bc9c'
  },
  ZIL: {
    symbol: 'ZIL',
    name: 'Zilliqa',
    color: '#49c1bf'
  },
  ZILLA: {
    symbol: 'ZILLA',
    name: 'Chainzilla',
    color: '#00004d'
  },
  ZRX: {
    symbol: 'ZRX',
    name: '0x',
    color: '#302c2c'
  }
}
